import styleService from '@nykaa/deals-utils/styles';
import styled from '../../theme';
const { getPaddingStyles, getFontStyles, } = styleService.utils;
export const Title = styled.div `
  ${({ text }) => getFontStyles(text)};
  ${({ padding }) => getPaddingStyles(padding)};
  display: -webkit-box;
  -webkit-box-orient: vertical;
  vertical-align: top;
  overflow: hidden;
  white-space: normal;
  word-wrap: break-word;
  text-overflow: ellipsis;
  -webkit-line-clamp:  ${({ text }) => text.maxLines.web};
`;
export const Description = styled.div `
  ${({ text }) => getFontStyles(text)};
  ${({ padding }) => getPaddingStyles(padding)};
  display: -webkit-box;
  -webkit-box-orient: vertical;
  vertical-align: top;
  overflow: hidden;
  white-space: normal;
  word-wrap: break-word;
  text-overflow: ellipsis;
  -webkit-line-clamp:  ${({ text }) => text.maxLines.web};

`;
export const List = styled.div `
  width: 100%;
  display: flex;
  white-space: nowrap;
  overflow-x: ${({ isDesktop }) => (isDesktop ? 'hidden' : 'auto')} ;
  overflow-y: hidden;
  height: auto;
  -ms-overflow-style: none;
  scrollbar-width: none; 
  ::-webkit-scrollbar { 
    display: none;
}
`;
export const Wrapper = styled.div `
 position: relative;
 .title-description {
   padding: 0 ${({ isDesktop }) => (isDesktop ? '3rem' : '1.25rem')};
 }
 @media only screen  and (min-width : 1600px) {
  margin-left: auto;
  margin-right: auto;
  max-width: 1600px;
  .title-description {
    padding: 0;
  }
}
`;
export const Container = styled.div `
  display: flex;
  transition: transform 0.4s ease-in;
  transform: translateX(${({ transform }) => transform}px);
`;
export const LeftArrowWrapper = styled.div `
  height: 85%;
  width: 90px;
  position: absolute;
  left: 12px;
  top: 0px;
  z-index: 1;
`;
export const RightArrowWrapper = styled.div `
  height: 85%;
  width: 90px;
  position: absolute;
  right: 12px;
  top: 0px;
  z-index: 1;
`;
export const Grid = styled.div `
  background-color: ${({ appBkgColor }) => appBkgColor};
  width: fill-available;
`;
